import * as Sentry from "@sentry/angular";

const DEFAULT_OPTIONS = {
	dsn: "https://b557d31410ec72048c8598975df63d8e@o4508587467800576.ingest.us.sentry.io/4508587473960960",
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.httpClientIntegration(),
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: false
		})
	],
	release: "jhm-1.0.0",
	tracesSampleRate: 1.0,
	tracePropagationTargets: [/^https{0,1}:\/\/.*\.jailhousemail\.com/],
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	debug: true
};

const ENV_OVERRIDES = {
	local: {
		replaysSessionSampleRate: 0
	},
	localhost: {
		replaysSessionSampleRate: 0
	},
	development: {
		replaysSessionSampleRate: 0
	},
	preview: {

	},
	staging: {
		debug: false,
		replaysSessionSampleRate: 0
	},
	production: {
		debug: false,
		replaysSessionSampleRate: 0.50
	}
};

export const initializeSentry = (
	environment: "local" | "localhost" | "development" | "preview" | "staging" | "production",
	options = {}
) => {
	options = {
		...DEFAULT_OPTIONS,
		...options,
		...ENV_OVERRIDES[environment],
		environment
	};

	Sentry.init(options);
}
